import axios from 'axios';
import { clearAdminToken, getAdminToken } from '../utils/adminAuth';

const healthHouseStationsApi = axios.create({
  baseURL: '/api/v1/health-house',
  withCredentials: true
});

healthHouseStationsApi.interceptors.request.use(
  (config) => {
    const token = getAdminToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

healthHouseStationsApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      clearAdminToken();
      if (typeof window !== 'undefined') {
        window.location.href = '/web/admin-login';
      }
    }
    return Promise.reject(error);
  }
);

export const listHealthHouseStations = async (params = {}) => {
  const response = await healthHouseStationsApi.get('/stations', { params });
  return response.data;
};

export const createHealthHouseStation = async (payload) => {
  const response = await healthHouseStationsApi.post('/stations', payload);
  return response.data;
};

export const updateHealthHouseStation = async (id, payload) => {
  const response = await healthHouseStationsApi.put(`/stations/${id}`, payload);
  return response.data;
};

export const patchHealthHouseStation = async (id, payload) => {
  const response = await healthHouseStationsApi.patch(`/stations/${id}`, payload);
  return response.data;
};

export const deleteHealthHouseStation = async (id) => {
  const response = await healthHouseStationsApi.delete(`/stations/${id}`);
  return response.data;
};

export const listHealthHouseMeasurementProjects = async () => {
  const response = await healthHouseStationsApi.get('/measurement-projects');
  return response.data;
};

export const listHealthHouseDeviceModels = async (params = {}) => {
  const response = await healthHouseStationsApi.get('/device-models', { params });
  return response.data;
};

export const createHealthHouseDeviceModel = async (payload) => {
  const response = await healthHouseStationsApi.post('/device-models', payload);
  return response.data;
};

export const updateHealthHouseDeviceModel = async (id, payload) => {
  const response = await healthHouseStationsApi.put(`/device-models/${id}`, payload);
  return response.data;
};

export const deleteHealthHouseDeviceModel = async (id) => {
  const response = await healthHouseStationsApi.delete(`/device-models/${id}`);
  return response.data;
};

export const applyHealthHouseStationModel = async (stationId, payload) => {
  const response = await healthHouseStationsApi.put(`/stations/${stationId}/device-model`, payload);
  return response.data;
};

export const updateHealthHouseStationCapabilities = async (stationId, payload) => {
  const response = await healthHouseStationsApi.put(`/stations/${stationId}/capabilities`, payload);
  return response.data;
};
